import {
  InstagramOutlined,
  LinkOutlined,
  TikTokOutlined,
} from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  Form,
  GetProp,
  Input,
  Row,
  Typography,
  UploadProps,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getBusinessInfo } from "redux-context/business";
import {
  removeLogo,
  updateBusinessInfo,
  uploadLogo,
} from "services/SauceService";
import LogoUpload from "components/logo-upload";

type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];

const BusinessInfo: React.FC = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const { business } = useSelector((state: any) => state.business);
  const [imageUrl, setImageUrl] = useState<string>(business?.logoUrl);
  const [file, setFile] = useState<FileType>();

  const handleRemoveImage = async () => {
    try {
      await removeLogo({ businessId: business._id });
    } catch (error) {
      console.error(error);
    }
  };

  const handleLogoChange = (
    selectedFile: FileType | undefined,
    previewUrl: string | undefined
  ) => {
    setFile(selectedFile);
    setImageUrl(previewUrl || "");
  };

  const handleUpload = async (file: FileType) => {
    const params = { logo: file, businessId: business._id };
    try {
      await uploadLogo(params);
    } catch (error) {
      console.error(error);
      message.error("Failed to upload logo");
    }
  };

  const onFinish = async () => {
    setLoading(true);
    if (file) await handleUpload(file);
    if (business?.logoUrl && !imageUrl) await handleRemoveImage();
    try {
      const businessId = business._id;
      const values = form.getFieldsValue(true);
      const params = {
        businessId,
        ...values,
      };
      await updateBusinessInfo(params);
      message.success("Business info updated successfully");
      dispatch(getBusinessInfo());
    } catch (error) {
      console.error(error);
      message.error("Failed to update business info");
    }
    setLoading(false);
  };

  useEffect(() => {
    form.resetFields();
    setImageUrl(business?.logoUrl);
  }, [business, form]);

  return (
    <Card className="business-info">
      <Row justify="center">
        <Col
          xs={22}
          style={{
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            padding: "0 48px",
          }}
        >
          <div style={{ width: "100%" }}>
            <Form
              form={form}
              initialValues={business}
              onFinish={onFinish}
              layout="vertical"
            >
              <Typography.Title
                level={2}
                className="title"
                style={{ marginBottom: 32 }}
              >
                Business Info
              </Typography.Title>
              <Form.Item label="Logo">
                <LogoUpload
                  value={imageUrl}
                  onChange={handleLogoChange}
                  loading={loading}
                />
              </Form.Item>
              <Form.Item name="businessName" label="Name">
                <Input />
              </Form.Item>
              <Form.Item name="aboutTheBrand" label="Description">
                <Input.TextArea />
              </Form.Item>
              <Form.Item name="website" label="Website">
                <Input
                  prefix={<LinkOutlined />}
                  placeholder="https://example.com"
                />
              </Form.Item>
              <Form.Item label="Links to social media" name="instagramUrl">
                <Input placeholder="Instagram" prefix={<InstagramOutlined />} />
              </Form.Item>
              <Form.Item name="tiktokUrl">
                <Input placeholder="TikTok" prefix={<TikTokOutlined />} />
              </Form.Item>
              <Row justify="end">
                <Button type="primary" htmlType="submit" loading={loading}>
                  Save
                </Button>
              </Row>
            </Form>
          </div>
        </Col>
      </Row>
    </Card>
  );

  // return (
  //   <Card className="business-info">
  //     <Row justify="center" gutter={[20, 20]}>
  //       <Col xs={8}>
  //         <Typography.Text>Logo</Typography.Text>
  //       </Col>
  //       <Col xs={16}>
  //         <Avatar src={business.logoUrl} size={100} />
  //       </Col>
  //       <Col xs={8}>
  //         <Typography.Text>Name of the business</Typography.Text>
  //       </Col>
  //       <Col xs={16}>
  //         <Typography.Text className="value">
  //           {business.businessName}
  //         </Typography.Text>
  //       </Col>
  //       <Col xs={8}>
  //         <Typography.Text>Website</Typography.Text>
  //       </Col>
  //       <Col xs={16}>
  //         <Typography.Text className="value">
  //           {business.website}
  //         </Typography.Text>
  //       </Col>
  //       <Col xs={8}>
  //         <Typography.Text>Instagram</Typography.Text>
  //       </Col>
  //       <Col xs={16}>
  //         <Typography.Text className="value">
  //           <InstagramOutlined style={{ marginRight: 8 }} />
  //           {business.instagramUrl ? (
  //             <a
  //               href={business.instagramUrl}
  //               target="_blank"
  //               rel="noopener noreferrer"
  //             >
  //               {business.instagramUrl}
  //             </a>
  //           ) : null}
  //         </Typography.Text>
  //       </Col>
  //       <Col xs={8}>
  //         <Typography.Text>TikTok</Typography.Text>
  //       </Col>
  //       <Col xs={16}>
  //         <Typography.Text className="value">
  //           <TikTokOutlined style={{ marginRight: 8 }} />
  //           {business.tiktokUrl ? (
  //             <a
  //               href={business.tiktokUrl}
  //               target="_blank"
  //               rel="noopener noreferrer"
  //             >
  //               {business.tiktokUrl}
  //             </a>
  //           ) : null}
  //         </Typography.Text>
  //       </Col>

  //       <Col xs={8}>
  //         <Typography.Text>Description</Typography.Text>
  //       </Col>
  //       <Col xs={16}>
  //         <Typography.Text className="value">
  //           {business.aboutTheBrand}
  //         </Typography.Text>
  //       </Col>
  //     </Row>
  //     <Row justify="end" style={{ marginTop: 40 }}>
  //       <Button icon={<EditOutlined />} onClick={onEditClick}>
  //         Edit
  //       </Button>
  //     </Row>
  //   </Card>
  // );
};

export default BusinessInfo;
